<template>
  <footer class="footer bg-white border-t border-gray-300 py-7 lg:py-16">
    <div class="container">
      <div class="flex flex-wrap lg:space-x-6 lg:flex-nowrap">
        <div class="flex justify-center flex-wrap text-center w-full md:flex-col lg:w-3/12 lg:text-left lg:block">
          <Link :href="localeRoute('frontend.index')">
            <img
              src="/frontend/assets/logo.svg"
              class="mb-2 lg:mb-0"
            >
          </Link>

          <div class="flex flex-wrap space-x-4 mx-auto">
            <a
              :href="__('layouts.components.footer.social-media.instagram.link')"
              target="_blank"
              :title="__('layouts.components.footer.social-media.instagram.title')"
            >
              <img src="/frontend/assets/social/instagram-black.svg">
            </a>
            <a
              :href="__('layouts.components.footer.social-media.facebook.link')"
              target="_blank"
              :title="__('layouts.components.footer.social-media.facebook.title')"
            >
              <img src="/frontend/assets/social/facebook-black.svg">
            </a>
            <a
              :href="__('layouts.components.footer.social-media.linkedin.link')"
              target="_blank"
              :title="__('layouts.components.footer.social-media.linkedin.link')"
            >
              <img src="/frontend/assets/social/linkedin-black.svg">
            </a>
          </div>
        </div>

        <div class="pt-12 flex flex-wrap w-full md:w-1/2 lg:w-5/12 lg:pt-0">
          <ul class="w-1/2 space-y-4 lg:space-y-3">
            <li class="block font-medium">
              <Link
                :href="localeRoute('frontend.index')"
                class="hover:underline"
              >
                {{ __('layouts.components.footer.all-vips') }}
              </Link>
            </li>
            <li class="block font-medium">
              <Link
                :href="localeRoute('frontend.categories.index')"
                class="hover:underline"
              >
                {{ __('layouts.components.footer.all-categories') }}
              </Link>
            </li>
            <li class="block font-medium">
              <Link
                :href="localeRoute('frontend.how-does-it-work')"
                class="hover:underline"
              >
                {{ __('layouts.components.footer.how-does-it-work') }}
              </Link>
            </li>
            <li class="block font-medium">
              <Link
                :href="localeRoute('frontend.business')"
                class="hover:underline"
              >
                {{ __('layouts.components.footer.business') }}
              </Link>
            </li>
          </ul>

          <ul class="w-1/2 space-y-4 lg:space-y-3">
            <li class="block font-medium">
              <Link
                :href="localeRoute('frontend.about-us')"
                class="hover:underline"
              >
                {{ __('layouts.components.footer.about-us') }}
              </Link>
            </li>
            <li class="block font-medium">
              <Link
                :href="localeRoute('frontend.news.index')"
                class="hover:underline"
              >
                {{ __('layouts.components.footer.news') }}
              </Link>
            </li>
            <li class="block font-medium">
              <Link
                :href="localeRoute('frontend.faq')"
                class="hover:underline"
              >
                {{ __('layouts.components.footer.faq') }}
              </Link>
            </li>
            <li class="block font-medium">
              <Link
                :href="localeRoute('frontend.contact')"
                class="hover:underline"
              >
                {{ __('layouts.components.footer.contact') }}
              </Link>
            </li>
            <li class="block font-medium">
              <Link
                :href="localeRoute('frontend.vip-signup')"
                class="hover:underline"
              >
                {{ __('layouts.components.footer.vip-signup') }}
              </Link>
            </li>
            <li
              v-if="country === 'de'"
              class="block font-medium"
            >
              <Link
                :href="localeRoute('frontend.impressum')"
                class="hover:underline"
              >
                {{ __('layouts.components.footer.impressum') }}
              </Link>
            </li>
          </ul>
        </div>

        <div class="pt-12 w-full md:w-1/2 lg:w-4/12 lg:pt-0">
          <span class="text-2xl font-bold block text-center lg:text-xl lg:text-left">
            {{ __('layouts.components.footer.newsletter.title') }}
          </span>

          <form
            class="w-full mt-3"
            @submit.prevent="form.post(localeRoute('frontend.newsletter.store'), {
              preserveScroll: true,
              onSuccess: () => form.reset(),
            })"
          >
            <div class="md:flex">
              <div class="grow">
                <input
                  id="email"
                  v-model="form.email"
                  type="email"
                  name="email"
                  class="block w-full rounded-lg border-black p-4 border-2 placeholder-gray-300 focus:ring-red focus:ring-offset-red focus:border-red"
                  :placeholder="__('layouts.components.footer.newsletter.email.placeholder')"
                >
              </div>
              <div class="ml-0 mt-3 md:ml-3 md:mt-0">
                <button
                  type="submit"
                  class="!py-4 w-full button-orange shadow-button-red block"
                >
                  {{ __('layouts.components.footer.newsletter.submit') }}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>

      <div class="border-gray-300 border-t mt-8 pt-4 text-xs text-center lg:flex lg:justify-between">
        <div>
          <i18n-t
            keypath="layouts.components.footer.copyright"
            scope="global"
          >
            <template #year>
              {{ new Date().getFullYear() }}
            </template>
            <template #link>
              <Link
                :href="localeRoute('frontend.index')"
                class="text-red hover:underline"
              >
                {{ __('layouts.components.footer.copyright-link') }}
              </Link>
            </template>
          </i18n-t>
        </div>

        <div>
          <Link
            :href="localeRoute('frontend.terms-and-conditions')"
            class="hover:underline"
          >
            {{ __('layouts.components.footer.terms') }}
          </Link>
          -
          <Link
            :href="localeRoute('frontend.privacy-statement')"
            class="hover:underline"
          >
            {{ __('layouts.components.footer.privacy') }}
          </Link>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import {useForm} from '@inertiajs/vue3';

export default {
  props: {
    country: {
      type: String,
      required: true,
    },
  },

  setup() {
    const form = useForm({email: ''});

    return {form};
  },
};
</script>
